import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getColor from "@insite/mobius/utilities/getColor";
import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";

orderHistoryTableStyles.reorderButton = mergeToNew(orderHistoryTableStyles.reorderButton, {
    color: "common.accent",
    sizeVariant: "medium",
    variant: "secondary",
});

orderHistoryTableStyles.dataTable = mergeToNew(orderHistoryTableStyles.dataTable, {
    css: css`
        th {
            background: ${getColor("secondary")};
        }
        tbody {
            tr {
                &:nth-child(even) {
                    background: ${getColor("secondary")};
                }
            }
        }
    `,
});
